import React, { Fragment } from "react";
import languages from "../../../data/languages";
import { TYPES } from "./constants";
import OptionItemNew from "./OptionItemNew";
import OptionItemExisting from "./OptionItemExisting";

const Translations = ({
                        className = "row",
                        storyType,
                        translations,
                        previewBackground,
                        previewLogo,
                        onChange,
                        onChangeBackground,
                        onChangeLogo,
                      }) => {
  const handleAddNewOption = ({
                                value,
                                language
                              }) => {
    const languageItem = translations ? translations.find(i => i.language === language) : {};
    const options = languageItem.options ? languageItem.options : [];
    onChange(language, "options", [...options, value]);
  };

  const handleChangeOption = ({
                                value,
                                index,
                                language
                              }) => {
    const languageItem = translations ? translations.find(i => i.language === language) : {};
    const options = languageItem.options ? languageItem.options.filter((opt, i) => i !== index) : [];
    onChange(language, "options", [...options, value]);
  };

  const handleRemove = ({
                          language,
                          index
                        }) => {
    const languageItem = translations ? translations.find(i => i.language === language) : {};
    const options = languageItem.options ? languageItem.options.filter((opt, i) => i !== index) : [];
    onChange(language, "options", options);
  };

  const languagesKeys = Object.keys(languages);

  return (
    <div className={className}>
      {languagesKeys
        .map((lang, index) => {
          const languageItem = translations ? translations.find(i => i.language === lang) : {};
          return (
            <div key={lang}
                 className={`col-4 ${((index + 1) % 3 === 0 || languagesKeys.length - 1 === index) ? "border-right" : ""} border-left  border-bottom`}>
              <label className="text-center mt-2">{languages[lang]}</label>

              <div className="form-group">
                <input
                  className="form-control form-control-sm"
                  type="text"
                  value={languageItem.title || ""}
                  onChange={ev => onChange(lang, "title", ev.target.value)}
                  placeholder="Title"
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control form-control-sm"
                  value={languageItem.content || ""}
                  onChange={ev => onChange(lang, "content", ev.target.value)}
                  placeholder="Content"
                />
              </div>

              {storyType !== TYPES.LINK ? (
                <div className="mb-2">
                  {(languageItem.options ? languageItem.options : [])
                    .map((option, index) => (
                      <OptionItemExisting
                        key={`${index}-${option}`}
                        index={index}
                        language={lang}
                        value={option}
                        onChange={handleChangeOption}
                        onRemove={handleRemove}
                      />
                    ))}
                  <OptionItemNew language={lang} onAdd={handleAddNewOption}/>
                </div>
              ) : (
                <Fragment>
                  <div className="form-group">
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      value={languageItem.url || ""}
                      onChange={ev => onChange(lang, "url", ev.target.value)}
                      placeholder="URL"
                    />
                  </div>

                  <div className="form-group">
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      value={languageItem.urlButtonName || ""}
                      onChange={ev => onChange(lang, "urlButtonName", ev.target.value)}
                      placeholder="Button label"
                    />
                  </div>
                </Fragment>
              )}

              <div className="form-group">
                <label>Logo</label>
                <input
                  className="form-control"
                  accept="image/*"
                  type="file"
                  name="logo"
                  placeholder="Upload Logo"
                  onChange={(ev) => onChangeLogo(lang, ev)}
                />
                {previewLogo[lang] && previewLogo[lang].preview && (
                  <div className="mb-3 text-center">
                    <img
                      src={previewLogo[lang].preview}
                      alt="Preview"
                      className="img-thumbnail"
                      style={{
                        maxWidth: "100%",
                        width: "auto",
                        marginTop: 20,
                        height: 100,
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="form-group">
                <label>Background</label>
                <input
                  className="form-control"
                  accept="image/*"
                  type="file"
                  name="background"
                  placeholder="Upload background"
                  onChange={(ev) => onChangeBackground(lang, ev)}
                />
                {previewBackground[lang] && previewBackground[lang].preview && (
                  <div className="mb-3 text-center">
                    <img
                      src={previewBackground[lang].preview}
                      alt="Preview"
                      className="img-thumbnail"
                      style={{
                        maxWidth: "100%",
                        width: "auto",
                        marginTop: 20,
                        height: 200,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default React.memo(Translations);



// WEBPACK FOOTER //
// ./src/views/pages/stories/translations.js